module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-pool.png?aa4dc56e352400c0293ce90cfe5e7a0e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-pool.png
// module id = 1042
// module chunks = 1